import { useI18n } from "@/lib/i18n";

export default function LanguageSwitcher({ className = "" }) {
    const { lang, setLang, supported } = useI18n();
    return (
        <div
            data-testid="language-switcher"
            className={`inline-flex items-center border border-[#C9A96E]/30 rounded-sm overflow-hidden ${className}`}
        >
            {supported.map((code) => (
                <button
                    key={code}
                    data-testid={`lang-btn-${code}`}
                    onClick={() => setLang(code)}
                    aria-pressed={lang === code}
                    className={`px-3 py-1.5 text-[10px] tracking-[0.28em] uppercase transition-colors ${
                        lang === code
                            ? "bg-[#C9A96E] text-[#050D1C]"
                            : "text-slate-300 hover:text-[#C9A96E]"
                    }`}
                >
                    {code.toUpperCase()}
                </button>
            ))}
        </div>
    );
}
